import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
const TEXTAREA_CLASSES = 'flex min-h-24 w-full rounded-md border border-input bg-card px-3 py-2 text-sm text-foreground ' +
    'placeholder:text-muted-foreground transition-colors duration-[var(--dur-quick)] ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:border-ring ' +
    'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive ' +
    'disabled:cursor-not-allowed disabled:bg-disabled disabled:text-disabled-foreground ' +
    'disabled:outline-1 disabled:-outline-offset-1 disabled:outline-disabled-foreground';
/** Token-driven multiline input. Matches Input's focus + invalid treatment. */
export const Textarea = forwardRef(({ className, ...props }, ref) => (_jsx("textarea", { ref: ref, className: cn(TEXTAREA_CLASSES, className), ...props })));
Textarea.displayName = 'Textarea';
